export const UPDATE_SEARCH = 'UPDATE_SEARCH'

export const updateSearch = data => ({
  type: UPDATE_SEARCH,
  payload: data
})
